
import * as __star__ from 'text-mask-addons';

const {
default: __default__,
createAutoCorrectedDatePipe,
createNumberMask,
emailMask,
__esModule
} = __star__;

export {
createAutoCorrectedDatePipe,
createNumberMask,
emailMask,
__esModule
};
export default __default__;
